'use client';
import { useClientTranslation } from '@/hook/translate';

export default function GotoText() {
  const { t } = useClientTranslation();
  return (
    <>{ t('goto') }</>
  );
}
